module.exports = __webpack_public_path__ + "static/seo-technologies-89702a3ef3c94b246b572052474632c3.png";